import {
  storageCanBeSet,
  cookiePrefix,
} from '@JohnLewisPartnership/pecr-util';
import storageManifest from '../../storageManifest.json';
import deleteCookie from '../helpers/cookie/deleteCookie';
import getCookie from '../helpers/cookie/getCookie';

export function pecrCheck(storageType, key) {
  return storageCanBeSet(storageManifest[storageType][key]);
}

export function getCookieGroupPermission(groupName) {
  const cookieGroupPermission = getCookie(`${cookiePrefix}${groupName}`);
  if (!cookieGroupPermission) {
    return 'nopref';
  }

  return cookieGroupPermission === '1' ? 'allow' : 'refuse';
}

export function allowCookieGroup(groupName) {
  document.cookie = `${cookiePrefix}${groupName}=1`;
}

export function refuseCookieGroup(groupName) {
  document.cookie = `${cookiePrefix}${groupName}=0`;
}

export function removeCookieGroupPreference(groupName) {
  deleteCookie({ name: `${cookiePrefix}${groupName}` });
}
